import React from 'react'
import styled from 'styled-components'
import Banner from '../../components/Banner'
import Title from '../../components/Title'
import Button from '../../components/Button'
import Paragraph from '../../components/Paragraph'
import img1 from '../../assets/static/about_img.jpg'
import { Link } from 'react-router-dom'
import img2 from '../../assets/static/about_img2.jpg'
import img3 from '../../assets/static/about_img3.jpg'
import video from '../../assets/static/video2.mp4'
import medal from '../../assets/static/medal.svg'
import shield from '../../assets/static/shield.svg'
import { useTranslation } from "react-i18next"


const About = () => {
  const { t } = useTranslation()
  return (
    <Main>
      <Banner>
        {t("about.hero.title")}
      </Banner>
      <Container>
        <Article1>
          <TitleContainer>
            <Title size="big">
              {t("about.intro.title")}
            </Title>
          </TitleContainer>
          <Grid2>
            <Left>
              <Title>
                {t("about.intro.subtitle")}
              </Title>
              <Paragraph>
                {t("about.intro.desc")}
              </Paragraph>
              <Paragraph>
                {t("about.intro.descTwo")}
              </Paragraph>
              <Link to="/solutions">
                <Button>{t("about.intro.cta")}</Button>
              </Link>
            </Left>
            <div>
              <Img src={img1} alt="" />
            </div>
          </Grid2>
        </Article1>
        <Article2>
          <TitleContainer>
            <Title color="primary" size="mid">
              {t("about.heroTwo.title")}
            </Title>
            <Title color="white" size="small">
              {t("about.heroTwo.desc")}
            </Title>
          </TitleContainer>
        </Article2>
        <Artiecle3 />
        <Article1>
          <TitleContainer>
            <Title size="small">
              {t("about.ourProces.title")}
            </Title>
          </TitleContainer>
          <Grid2>
            <div>
              <Video autoPlay muted controls={true} loop>
                <source src={video} type="video/mp4" />
              </Video>
            </div>
            <Left>
              <Title size="small">
                {t("about.ourProces.items.0.title")}
              </Title>
              <ImgPContainer>
                <Iso src={img3} alt="" />
                <Paragraph>
                  {t("about.ourProces.items.0.desc")}
                </Paragraph>
              </ImgPContainer>
            </Left>
          </Grid2>
        </Article1>
        <Article4>
          <div>
            <Left>
              <Title size="small">
                {t("about.ourProces.items.1.title")}
              </Title>
              <ImgPContainer>
                <Svg src={medal} alt="" />
                <div>
                  <Paragraph>
                   {t("about.ourProces.items.1.desc")}
                  </Paragraph>
                  <Paragraph>
                    {t("about.ourProces.items.1.descTwo")}
                  </Paragraph>
                </div>
              </ImgPContainer>
            </Left>{' '}
            <Left>
              <Title size="small">{t("about.ourProces.items.2.title")}</Title>
              <ImgPContainer>
                <Svg src={shield} alt="" />
                <Paragraph>
                  {t("about.ourProces.items.2.desc")}
                </Paragraph>
              </ImgPContainer>
            </Left>
          </div>
        </Article4>
      </Container>
    </Main>
  )
}

export default About

const Main = styled.main``
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr minmax(375px, 1200px) 1fr;
  background-color: ${({ theme }) => theme.white};

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

/* const Span = styled.span`
  color: #000;
` */

const Article1 = styled.article`
  grid-column: 2/3;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    grid-column: 1/2;
    padding: 0 20px;
  }
`

const TitleContainer = styled.div`
  text-align: center;
  margin: 75px 0;
`

const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const Article2 = styled.article`
  grid-column: 1/4;
  background-color: ${({ theme }) => theme.bgWeb};
`

const Artiecle3 = styled.article`
  grid-column: 1/4;
  background-image: url(${img2});
  height: 50vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`

const ImgPContainer = styled.div`
  display: flex;
  align-items: flex-start;
`

const Iso = styled.img`
  width: 100px;
  margin-right: 20px;
  object-fit: contain;
  margin-top: 25px;
`

const Svg = styled.img`
  height: 75px;
  margin-right: 20px;
  object-fit: contain;
  margin-top: 25px;
`

const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const Article4 = styled.article`
  grid-column: 1/4;
  margin-bottom: 30px;
  background-color: ${({ theme }) => theme.grayLight};
  display: grid;
  grid-template-columns: 1fr minmax(375px, 1200px) 1fr;
  padding: 50px 0;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    box-sizing: border-box;
    padding: 0 20px;
  }
  & > div {
    grid-column: 2/3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 50px;
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      box-sizing: border-box;
      padding: 0 20px;
    }
  }
`
